module.exports = __webpack_public_path__ + "static/media/prospectiveClientBackground.d3edfba6.jpg";